import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import useGetHomeSection from "../common/GNB/queries/useGetHomeSection";
import { HomeSkeleton } from "./components/Skeleton";
import { calculateSelectedBook, useHomeIpSelect } from "./hooks/useHomeIpSelect";
import StudentHomeContent from "./StudentHomeContent";
import TeacherHomeContent from "./TeacherHomeContent";
const Home = ()=>{
    var _data_sectionsMap, _ipSelectSection_content, _data_sections, _data_home;
    const { homeType , homeId  } = useHomeSwitchStore();
    // 홈 페이지 진입 시 homeId를 Mixpanel super property로 등록
    useEffect(()=>{
        if (homeId && window.mixpanel) {
            window.mixpanel.register({
                "Home Id": homeId
            });
        }
    }, [
        homeId
    ]);
    // 1. IP Select 상태 관리 (ipSelectSourceId, 선택 콜백)
    const { ipSelectSourceId , handleSelectSource , isDefaultSelected  } = useHomeIpSelect();
    // 2. API 호출 (ipSelectSourceId 변경 시 재호출)
    const { data , isLoading , isFetching  } = useGetHomeSection({
        ipSelectSourceId
    });
    // 3. ip_select 섹션에서 items 추출 및 selectedBook 계산
    const ipSelectSection = data === null || data === void 0 ? void 0 : (_data_sectionsMap = data.sectionsMap) === null || _data_sectionsMap === void 0 ? void 0 : _data_sectionsMap["ip_select"];
    const selectedBook = calculateSelectedBook(ipSelectSection === null || ipSelectSection === void 0 ? void 0 : (_ipSelectSection_content = ipSelectSection.content) === null || _ipSelectSection_content === void 0 ? void 0 : _ipSelectSection_content.items, ipSelectSourceId);
    var _data_sections_sort;
    // 4. 전체 섹션 정렬
    const allSections = (_data_sections_sort = data === null || data === void 0 ? void 0 : (_data_sections = data.sections) === null || _data_sections === void 0 ? void 0 : _data_sections.sort((a, b)=>a.sortOrder - b.sortOrder)) !== null && _data_sections_sort !== void 0 ? _data_sections_sort : [];
    // 5. IP Select props (selectedBook이 없으면 null → SectionRenderer에서 스켈레톤 표시)
    const ipSelectProps = selectedBook ? {
        selectedBook,
        onSelectSource: handleSelectSource,
        isLoading: isFetching,
        isDefaultSelected,
        // 응답 기준 homeId (과목 전환 시 IpSelectContainer 리마운트 key)
        homeKey: data === null || data === void 0 ? void 0 : (_data_home = data.home) === null || _data_home === void 0 ? void 0 : _data_home.homeId
    } : null;
    if (isLoading) return /*#__PURE__*/ _jsx(HomeSkeleton, {});
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col overflow-x-hidden",
        children: homeType === "teacher" ? /*#__PURE__*/ _jsx(TeacherHomeContent, {
            sections: allSections,
            ipSelectProps: ipSelectProps
        }) : /*#__PURE__*/ _jsx(StudentHomeContent, {
            sections: allSections,
            ipSelectProps: ipSelectProps
        })
    });
};
export default Home;
